import { Button } from "@/components/ui/button";
import { Eye, Edit, Trash2 } from "lucide-react";
import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle, AlertDialogTrigger } from "@/components/ui/alert-dialog";

interface StageActionButtonsProps {
  stage: {
    id: string;
    name: string;
    status: string;
  };
  canDelete: boolean;
  onView: () => void;
  onEdit: () => void;
  onDelete: () => void;
}

export function StageActionButtons({ 
  stage, 
  canDelete, 
  onView, 
  onEdit, 
  onDelete 
}: StageActionButtonsProps) {
  if (stage.status !== 'completed') return null;

  return (
    <div className="flex flex-wrap gap-2 mt-2">
      <Button
        size="sm"
        variant="outline"
        onClick={onView}
        className="flex-1 min-w-fit"
      >
        <Eye className="w-3 h-3 mr-1" />
        Προβολή
      </Button>
      
      <Button
        size="sm"
        variant="outline"
        onClick={onEdit}
        className="flex-1 min-w-fit"
      >
        <Edit className="w-3 h-3 mr-1" />
        Επεξεργασία
      </Button>
      
      {canDelete && (
        <AlertDialog>
          <AlertDialogTrigger asChild>
            <Button
              size="sm"
              variant="destructive"
              className="flex-1 min-w-fit"
            >
              <Trash2 className="w-3 h-3 mr-1" />
              Διαγραφή
            </Button>
          </AlertDialogTrigger>
          <AlertDialogContent>
            <AlertDialogHeader>
              <AlertDialogTitle>Επιβεβαίωση Διαγραφής</AlertDialogTitle>
              <AlertDialogDescription>
                Είστε σίγουροι ότι θέλετε να διαγράψετε το στάδιο "{stage.name}";
                Αυτή η ενέργεια δεν μπορεί να αναιρεθεί.
              </AlertDialogDescription>
            </AlertDialogHeader>
            <AlertDialogFooter>
              <AlertDialogCancel>Ακύρωση</AlertDialogCancel>
              <AlertDialogAction 
                onClick={onDelete}
                className="bg-destructive text-destructive-foreground hover:bg-destructive/90"
              >
                Διαγραφή
              </AlertDialogAction>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialog>
      )}
    </div>
  );
}